export default __webpack_public_path__ + "77d38b019ed704337ec480b2d42a2208.png";